import gql from 'graphql-tag'

export const products = gql`
  query products {
    products{
      id
      product
      status      
      brands{
        id
        brand
        status
      }
    }
  }
`
